<template>
  <div class="visaList">
    <ld-header>{{ visaSearchInfo.country }}</ld-header>
    
    <van-dropdown-menu>
      <van-dropdown-item
        v-model="params.visaType"
        :options="option1"
        @change="getList"
      />
      <van-dropdown-item
        v-model="params.isSpeed"
        :options="option2"
        @change="getList"
      />
      <van-dropdown-item
        ref="item"
        :title="visaSearchInfo.consularDistrictName"
      >
        <div class="drop-box">
          <ul class="van-clearfix">
            <li
              class="item-3"
              v-for="(consular, index) in visaSearchInfo.ConsularList"
              :key="index"
              @click="selectConsular(consular)"
            >
              <a :class="{ 'active': consular.checked }">{{ consular.distName }}</a>
            </li>
          </ul>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>

    <mescroll-vue
      class="visa-list__wrapper"
      ref="mescroll"
      :down="down"
    >
      <div class="visa-list__box">
        <div
          v-for="(visa, i) in visaList"
          :key="i"
          class="sign-item gray van-hairline--top van-hairline--bottom"
          @click="select(visa)"
        >
          <h3 class="black">
            {{ visa.visaName }}
            <van-tag
              class="vertical-text-bottom"
              v-if="visa.isSpeed === '1'"
            >
              加急
            </van-tag>
          </h3>
          <div>{{ visa.expiryDate }}</div>
          <div>{{ visa.retentionperiod }} 停留次数{{ visa.immigrationNo }}</div>
          <van-row>
            <van-col span="12">
              {{ visa.visaWeekDay }}
            </van-col>
            <van-col
              span="10"
              class="sign_price font16 font-bold text-right money-color"
            >
              <dfn>¥</dfn><span> {{ visa.salePrice }}</span>
            </van-col>
          </van-row>
        </div>
      </div>
      <ld-no-more
        v-if="visaList.length === 0"
        text="未查询到相关数据！"
      />
    </mescroll-vue>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Tag } from 'vant'
import { mapGetters } from 'vuex'
import ldNoMore from 'Common/ldNoMore'

import VisaBookInterator, { VisaTypes, IsSpeeds } from 'Domain/use-cases/visa-book-interactor'

export default {
  name: 'VisaList',
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    ldNoMore,
    MescrollVue: () => import('mescroll.js/mescroll.vue')
  },
  data () {
    return {
      down:{ use: false },
      params: {
        visaType: VisaTypes[0].value,
        isSpeed: IsSpeeds[0].value
      },
      option1: VisaTypes,
      option2: IsSpeeds,
      visaList: []
    }
  },
  async created () {
    this.getList()
  },
  methods: {
    selectConsular (consular) {
      this.visaSearchInfo.ConsularList.forEach(c => c.checked = false)
      consular.checked = true
      this.visaSearchInfo.consularDistrictName = consular.distName
      this.visaSearchInfo.consularDistId = consular.id
      this.$refs['item'].toggle(false)
      this.getList()
    },
    async getList () {
      const { data } = await VisaBookInterator.getVisaList({
        ...this.visaSearchInfo,
        ...this.params
      })
      this.visaList = data
    },
    select (visa) {
      this.visaSearchInfo.VisaDetail = visa
      this.$router.push('/visa/detail')
    }
  },
  computed: {
    ...mapGetters({
      visaSearchInfo: 'visa/visaSearchInfo',
      travelerList: 'visa/travelerList'
    })
  }
}
</script>

<style lang="less">
.visaList {
  
  .drop-box {
    padding: 10px 16px;
    ul {
      padding: 10px 0;
      li {
        padding: 5px 10px;
      }
      li.active {
        border: 1px solid @color-background-main;
        color: @color-background-main;
      }
      li.item-3 {
        width: 33.33333333333%;
        float: left;
        a {
          display: block;
          text-align: center;
          border: 1px solid #ccc;
          color: @color-text-deepGray;
          font-size: 12px;
          border-radius: 2px;
          padding: 0 5px;
          height: 28px;
          line-height: 28px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        a.active {
          border: 1px solid @color-background-main;
          color: @color-background-main;
        }
      }
    }
  }
  
  .visa-list__wrapper {
    height: calc(100vh - 104px);
  }

  .visa-list__box {
    background: #fff;

    .sign-item {
      padding: 10px 12px 8px 20px;
      margin-left: 12px;
      font-size: 12px;

      h3 {
        font-size: 16px;
        margin: 0;
        margin-bottom: 5px;
      }

      div {
        margin-bottom: 3px;
      }
    }
  }
}

</style>
